export default __webpack_public_path__ + "static/media/titles.99bbc6d1.txt";